export function flushCookies(ctx) {
  const cookies = ctx.$q.cookies;
  const cookiesName = Object.keys(cookies.all())

  cookiesName.forEach(name => { cookies.remove(name) });

  return ctx.$q.cookies.all();
};